// local
import { HttpLoadingService } from 'src/app/core/services/http-loading/http-loading.service';
import { ProfileService } from 'src/app/core/services/profile/profile.service';
import { environment } from 'src/environments/environment';

// third party
import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

import { GraphApiProfile } from '../../services/profile/graph-api-profile';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public profile?: GraphApiProfile;
  /** "TBtu - UAT" -> app "TBtu", environment "UAT" (none in production). */
  public readonly appName: string = environment.applicationName.split(' - ')[0];
  public readonly environmentName: string | null = environment.applicationName.split(' - ').slice(1).join(' - ') || null;

  constructor(
    private authService: MsalService,
    private profileService: ProfileService,
    public loadingService: HttpLoadingService,
  ) { }

  /** Phones: the rail is a drawer, open while the body has "nav-open" (side-nav closes it on navigation). */
  toggleNav(): void { document.body.classList.toggle('nav-open'); }

  ngOnInit(): void {
    this.profileService.getProfile().subscribe((profile) => {
      this.profile = profile;
    });
  }

  get displayName(): string {
    const name = [this.profile?.givenName, this.profile?.surname].filter(n => n).join(' ');
    return name || this.authService.instance.getActiveAccount()?.name || '';
  }

  get initials(): string {
    const parts = this.displayName.split(/\s+/).filter(p => p);
    return parts.length ? (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase() : '?';
  }

  logout() {
    this.authService.logoutRedirect();
  }
}
